import IconHOC from '../IconHOC';

import { ReactComponent as MessageCircleIcon } from './messageCircle.svg';

export const MessageCircle = IconHOC(MessageCircleIcon);
